

class SizeChart extends window.HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('input[type="checkbox"]');
   
  }

  connectedCallback() {
    if (!this.toggle) return;
    this.toggle.addEventListener('change', () => {
        this.updateSizeChart();
     });
     this.updateSizeChart();
  }

    updateSizeChart() {
        const size = this.toggle.checked ? 'cm' : 'in';
        this.dataset.sizeActive = size;
    }

}

window.customElements.define('size-chart', SizeChart);